import React from 'react';
import Switch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';
export default function AssignmentsContentPanelSwitch(props) {
  return (
    <div className={props.cssClass}>
      <span className="section-title-label">{props.text}</span>
      <Switch color="primary" disabled={props.disabled} checked={props.checked} onChange={props.onChange} />
    </div>
  );
}

AssignmentsContentPanelSwitch.propTypes = {
  cssClass: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};
